import { useSelector } from 'src/hooks/useSelector';

export default function useUrl(): string {
    return useSelector(({ router: { location } }) => location.pathname + location.search);
}
